"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const LegacyNavLink_atom_1 = require("./LegacyNavLink.atom");
const RevisedNavLink_atom_1 = require("./RevisedNavLink.atom");
const NavLink = (props) => {
    const isLegacyBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    if (isLegacyBehaviour) {
        return react_1.default.createElement(LegacyNavLink_atom_1.LegacyNavLink, Object.assign({}, props));
    }
    return react_1.default.createElement(RevisedNavLink_atom_1.RevisedNavLink, Object.assign({}, props));
};
exports.NavLink = NavLink;
//# sourceMappingURL=NavLink.atom.js.map